import types from './modalTypes';

export const setModalStatus = status => ({
  type: types.SET_MODAL_STATUS,
  payload: status,
});
